<app-shared-navbar
  [brandRoute]="'/'"
  [siteName]="sitename"
  [showSiteName]="!!sitename"
  [menuItems]="menuItems"
  [profileMenuItems]="profileMenuItems"
  [avatarSrc]="imageSrc"
  [showNotifications]="showNotifications"
  [notificationPermission]="notificationPermission"
  [navbarClass]="navbarClass"
  (itemSelected)="onNavbarAction($event)">
</app-shared-navbar>

<ng-template #siteEditStatusDialog let-modal>
  <div class="modal-header">
    <h4 class="modal-title">INFO</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      &nbsp; Site Settings saving under progress, please try after its completed
    </p>
  </div>
  <div class="modal-footer"></div>
</ng-template>
